/**
 * Responsive utility functions for suggested item section
 * Used by both ScanToCart and Scanpack components
 */

export const FOCUS_DESKTOP_MIN_WIDTH = 900;

export const getFontSize = (windowWidth) => {
  if (windowWidth > 870 && windowWidth < 1070) {
    return '30%';
  } else if (windowWidth >= 1070 && windowWidth < 1350) {
    return '35%';
  } else if (windowWidth >= 1350 && windowWidth < 1700) {
    return '40%';
  } else {
    return '50%';
  }
};

export const getWidth = (windowWidth) => {
  if (windowWidth > 870 && windowWidth < 1090) {
    return 300;
  } else if (windowWidth >= 1090 && windowWidth < 1450) {
    return 340;
  } else if (windowWidth >= 1450 && windowWidth < 1650) {
    return 400;
  } else {
    return 450;
  }
};

export const getMargin = (windowWidth) => {
  if (windowWidth > 870 && windowWidth < 1199) {
    return '1.65rem';
  } else if (windowWidth >= 1200 && windowWidth < 1450) {
    return '1.71rem';
  } else if (windowWidth >= 1450 && windowWidth < 1650) {
    return '1.8rem';
  } else {
    return '1.95rem';
  }
};

